import { createApi } from '@reduxjs/toolkit/query/react'
import { customClientBaseQuery } from './customElxFetchBase'

export const clientApi = createApi({
  reducerPath: 'clientApi',
  baseQuery: customClientBaseQuery,
  tagTypes: ['Client'],
  endpoints: (builder) => ({
    getClientList: builder.query({
      query() {
        return {
          url: 'aftermarketClient/all',
          method: 'GET',
          credentials: 'include',
        }
      },
      transformResponse: (result: any) => result.data.clientList,
    }),

    createClient: builder.mutation({
      query(data) {
        return {
          url: 'aftermarketClient/create',
          method: 'POST',
          body: data,
          credentials: 'include',
        }
      },
    }),

    updateClientDetails: builder.mutation({
      query(data) {
        return {
          url: 'aftermarketClient/update',
          method: 'POST',
          body: data,
          credentials: 'include',
        }
      },
    }),

    updateClientStatus: builder.mutation({
      query(data) {
        return {
          url: 'aftermarketClient/update-status',
          method: 'POST',
          body: data,
          credentials: 'include',
        }
      },
    }),
  }),
})

export const {
  useGetClientListQuery,
  useCreateClientMutation,
  useUpdateClientDetailsMutation,
  useUpdateClientStatusMutation,
} = clientApi
